/**
 * Helper text to show when the text field is invalid
 */

enum INPUT_RULE_DESCRIPTIONS {
	TITLE = 'Title should be less than 100 characters and should not contain special characters',
	DESCRIPTION = 'Description should not contain special characters',
}

class Validators {
	static ERROR_DESCRIPTIONS = INPUT_RULE_DESCRIPTIONS;

	/**
	 * @param {string} str
	 */
	static isEmpty(str: string): boolean {
		return str === null || str === undefined || str.trim() === '';
	}

	/**
	 * @param {string} str
	 */
	static hasSpecialCharacters(str: string){
		return /[.@()~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str);
	}

	/**
	 * @param {string} str
	 */
	static lessThan100Characters(str: string){
		return str.length < 100;
	}

	/**
	 * @param {string} str
	 * @return {boolean}
	 */
	static isTitleValid(str: string): boolean {
		return !this.isEmpty(str) && !this.hasSpecialCharacters(str) && this.lessThan100Characters(str);
	}

	/**
	 * @param {string} str
	 * @return {boolean}
	 */
	static isDescriptionValid(str: string): boolean {
		return !this.isEmpty(str) ? !this.hasSpecialCharacters(str) : true;
	}

}

export default Validators;
